import React, { createContext, useContext, useMemo } from 'react';
import type {
  MyGreenhouseProps,
  MyGreenhousePaths,
} from 'talent_matching/types';

interface MyGreenhouseTabContextValue {
  paths: MyGreenhousePaths;
}

const MyGreenhouseTabContext = createContext<
  MyGreenhouseTabContextValue | undefined
>(undefined);

export const useMyGreenhouseTabContext = () => {
  const context = useContext(MyGreenhouseTabContext);
  if (!context) {
    throw new Error(
      'useMyGreenhouseTabContext must be used within a MyGreenhouseTabContextProvider'
    );
  }
  return context;
};

type ProviderProps = {
  myGreenhouseProps: MyGreenhouseProps;
  children: React.ReactNode;
};

export const MyGreenhouseTabContextProvider = ({
  myGreenhouseProps,
  children,
}: ProviderProps) => {
  const contextValue = useMemo(
    () => ({
      paths: myGreenhouseProps.paths,
    }),
    [myGreenhouseProps.paths]
  );

  return (
    <MyGreenhouseTabContext.Provider value={contextValue}>
      {children}
    </MyGreenhouseTabContext.Provider>
  );
};
